import React, { useContext } from "react";
import { Card, ListGroup } from "react-bootstrap";
import { DebugContext } from "../../contexts/DebugContext";
import { IInteriorProductSubGroup } from "../../models/IChainInfo";
import { EditorContext } from "../EditorCommon/EditorContext";
import { InteriorDragContext } from "./InteriorImageDragContext";
import "./ProductSubGroup.scss";


export function ProductSubGroup(props: {
    subGroup: IInteriorProductSubGroup,
}) {

    const dragContext = useContext(InteriorDragContext);
    const ec = useContext(EditorContext);
    const debugContext = useContext(DebugContext);

    function mouseDown(evt: React.MouseEvent | React.TouchEvent) {
        dragContext.setInfo({
            subGroup: props.subGroup,
            isDragging: true,
            initialCoords: { x: 0, y: 0 },
            item: undefined,
            mouseOffset: {
                x: props.subGroup.products[0].defaultSize.x / 2,
                y: props.subGroup.products[0].defaultSize.y / 2,
            }
        });
        if (!(window as any).TouchEvent || !(evt.nativeEvent instanceof TouchEvent)) {
            evt.preventDefault();
        }
    }

    function mouseUp() {
        dragContext.setInfo(undefined);
    }

    const interiorMaterialId = ec.cabinet.interiorMaterialId;
    const materialWithPicture = props.subGroup.products
        .flatMap(p => p.materials)
        .find(mat => mat.interiorMaterialId === interiorMaterialId && mat.picturePath)
        ;

    const imageUrl = materialWithPicture?.picturePath
        ?? props.subGroup.imageUrl
        ?? "";

    return (
        <ListGroup.Item>
            <Card className="product-sub-group"

                onMouseDown={mouseDown}
                onMouseUp={mouseUp}
            >
                <img src={imageUrl}
                    className="card-img-top"
                    loading="lazy"
                    alt="" />
                <Card.Title>
                    {debugContext.value.displayExtendedProductInfo && (props.subGroup.externalId + " - ")}
                    {props.subGroup.name}
                </Card.Title>
            </Card>

        </ListGroup.Item>
    );
}

